// extracted by mini-css-extract-plugin
module.exports = {"confirmationBlock":"ConfirmationPopup_confirmationBlock__2Cmhh"};